import { render } from "./Assessment.vue?vue&type=template&id=242ae9c9&scoped=true"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"

import "./Assessment.vue?vue&type=style&index=0&id=242ae9c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242ae9c9"]])

export default __exports__